import { addHours, format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import Chip from '../common/chip'
import { numberWithCommas } from '../../utils'
import { CryptoTransaction } from '../../types'
import { CryptoTransactionStatus } from '../../lib'
import HashIcon from '../../assets/icons/hash-icon.svg'
import SendTxIcon from '../../assets/icons/send-tx-icon.svg'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import ReceiveTxIcon from '../../assets/icons/receive-tx-icon.svg'
import MoneyGreenIcon from '../../assets/icons/money-icon-green.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

const CryptoTransactionListItem = ({
  transactionData,
  handleRedirectToTransactionDetails
}: {
  transactionData: CryptoTransaction
  handleRedirectToTransactionDetails: (selectedTransactionData: CryptoTransaction) => void
}) => {
  const { t } = useTranslation(['crypto-management'])

  return (
    <>
      <div
        className="customer-details-list-item-data-container"
        onClick={() => handleRedirectToTransactionDetails(transactionData)}
      >
        <div className="customer-company-table-column customer-company-table-width-10 display-none-xlg">
          <div className="customer-details-list-item-icon">
            <img
              src={CalendarIcon}
              alt="calendar-icon"
            />
          </div>
          <div className="customer-details-list-item-text">{format(addHours(new Date(transactionData.blockTimestamp), 5), 'dd/MM/yyyy')}</div>
        </div>
        <div className="customer-company-table-column customer-company-table-width-45">
          <div className="customer-details-list-item-icon">
            <img
              src={HashIcon}
              alt="hash-icon"
            />
          </div>
          <div className="customer-details-list-item-text">{transactionData.transactionId}</div>
        </div>
        <div className="customer-company-table-column customer-company-table-width-15 customer-company-display-none-lg">
          <div className="customer-details-list-item-icon">
            <img
              alt="money-icon"
              src={MoneyGreenIcon}
            />
          </div>
          <div className="customer-details-list-item-text">
            {transactionData.status === CryptoTransactionStatus.FAILED
              ? `${numberWithCommas(Number(0))} ${transactionData.tokenTransferred}`
              : `${numberWithCommas(
                  Number(transactionData.valueTransferred / transactionData.decimals) === 0
                    ? Number(0).toFixed(2)
                    : Number(transactionData.valueTransferred / transactionData.decimals) >= 1
                    ? Number(transactionData.valueTransferred / transactionData.decimals).toFixed(2)
                    : Number(transactionData.valueTransferred / transactionData.decimals).toFixed(String(transactionData.decimals).length - 1)
                )} ${transactionData.tokenTransferred}`}
          </div>
        </div>
        <div className="customer-company-table-column customer-company-table-width-20 customer-company-display-none-sm">
          <div className="customer-details-list-item-icon">
            {transactionData.type === 'in' ? (
              <img
                src={ReceiveTxIcon}
                alt="receive-tx-icon"
              />
            ) : (
              <img
                src={SendTxIcon}
                alt="send-tx-icon"
              />
            )}
          </div>
          {transactionData.status === CryptoTransactionStatus.FAILED ? <div className="customer-details-list-item-text">N/A</div> : <div className="customer-details-list-item-text">{transactionData.walletAddress}</div>}
        </div>
        <div className="customer-company-table-column customer-company-table-width-10">
          <div className="customer-details-list-item-chip-container">
            <Chip
              status={transactionData.status === CryptoTransactionStatus.PENDING ? 'processing' : transactionData.status === CryptoTransactionStatus.FAILED ? 'error' : 'success'}
              label={
                transactionData.status === CryptoTransactionStatus.PENDING
                  ? t('transaction.status.processing')
                  : transactionData.status === CryptoTransactionStatus.FAILED
                  ? t('transaction.status.failed')
                  : t('transaction.status.confirmed')
              }
            />
          </div>
          <div className="customer-details-list-item-arrow-right">
            <img
              src={ArrowRightIcon}
              alt="arrow-right-icon"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default CryptoTransactionListItem
